import API_BASE_URL from './config';
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './MeritConfoShowList.css';

function MeritConfoShowList() {
  const [shows, setShows] = useState([]);
  const [error, setError] = useState('');
  const [timeRemaining, setTimeRemaining] = useState({});

useEffect(() => {
    fetch(`${API_BASE_URL}/merit-confo/shows`)
      .then((res) => {
        if (!res.ok) {
          return res.text().then((text) => {
            throw new Error(`HTTP ${res.status}: ${text || res.statusText}`);
          });
        }
        return res.text(); // Get raw text first for debugging
      })
      .then((text) => {
        console.log('MeritConfoShowList raw response:', text); // Log raw response
        try {
          const data = JSON.parse(text);
          console.log('Shows fetched:', { count: data.length });
          setShows(data);
        } catch (err) {
          throw new Error('Failed to parse shows: ' + err.message);
        }
      })
      .catch((err) => {
        console.error('Error fetching shows:', err.message);
        setError(`Failed to fetch shows: ${err.message}`);
      });
  }, []);

  useEffect(() => {
    const timeZone = 'America/Detroit'; // Michigan (EDT)
    const updateTimers = () => {
      const now = new Date();
      const newTimeRemaining = {};
      const today = new Date(now.toLocaleString('en-US', { timeZone }));
      today.setHours(0, 0, 0, 0);

      shows.forEach((show) => {
        const startDate = new Date(show.startDate);
        const endDateTime = new Date(show.endDate);
        startDate.setHours(0, 0, 0, 0);

        if (startDate > today) {
          // Pending show (starts in the future)
          newTimeRemaining[show._id] = 'Pending';
        } else if (endDateTime > now) {
          // Open show (started and not yet closed)
          const diffMs = endDateTime - now;
          const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));
          const hours = Math.floor((diffMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
          const seconds = Math.floor((diffMs % (1000 * 60)) / 1000);
          newTimeRemaining[show._id] = `${days}d ${hours}h ${minutes}m ${seconds}s`;
        } else {
          // Closed show
          newTimeRemaining[show._id] = 'Closed';
        }
      });

      setTimeRemaining(newTimeRemaining);
    };

    updateTimers();
    const interval = setInterval(updateTimers, 1000);
    return () => clearInterval(interval);
  }, [shows]);

  if (error) {
    return <p style={{ textAlign: 'center', color: 'red' }}>{error}</p>;
  }

  const timeZone = 'America/Detroit';
  const now = new Date();
  const today = new Date(now.toLocaleString('en-US', { timeZone }));
  today.setHours(0, 0, 0, 0);

  // Separate shows into Pending, Open, and Closed
  const pendingShows = shows.filter((show) => {
    const startDate = new Date(show.startDate);
    startDate.setHours(0, 0, 0, 0);
    return startDate > today;
  });
  const openShows = shows.filter((show) => {
    const startDate = new Date(show.startDate);
    const endDateTime = new Date(show.endDate);
    startDate.setHours(0, 0, 0, 0);
    return startDate <= today && endDateTime > now;
  });
  const closedShows = shows.filter((show) => new Date(show.endDate) <= now);

  const formatDate = (date) => {
    return new Date(date).toLocaleString('en-US', {
      month: 'numeric',
      day: 'numeric',
      year: 'numeric',
      timeZone,
    });
  };

  const formatDateTime = (date) => {
    return new Date(date).toLocaleString('en-US', {
      month: 'numeric',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
      timeZone,
    });
  };

  const renderShowTable = (shows, title) => (
    <div style={{ marginBottom: '40px' }}>
      <h2>{title}</h2>
      {shows.length === 0 ? (
        <p>No {title.toLowerCase()} found.</p>
      ) : (
        <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '20px' }}>
          <thead>
            <tr style={{ backgroundColor: '#f2f2f2' }}>
              <th style={{ border: '1px solid #ddd', padding: '8px' }}>Name</th>
              <th style={{ border: '1px solid #ddd', padding: '8px' }}>Location</th>
              <th style={{ border: '1px solid #ddd', padding: '8px' }}>Region</th>
              <th style={{ border: '1px solid #ddd', padding: '8px' }}>Start Date</th>
              <th style={{ border: '1px solid #ddd', padding: '8px' }}>End Date</th>
              <th style={{ border: '1px solid #ddd', padding: '8px' }}>Status</th>
              <th style={{ border: '1px solid #ddd', padding: '8px' }}>Breed</th>
              <th style={{ border: '1px solid #ddd', padding: '8px' }}>Judge</th>
              <th style={{ border: '1px solid #ddd', padding: '8px' }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {shows.map((show) => (
              <tr key={show._id}>
                <td style={{ border: '1px solid #ddd', padding: '8px' }}>{show.name}</td>
                <td style={{ border: '1px solid #ddd', padding: '8px' }}>{show.location}</td>
                <td style={{ border: '1px solid #ddd', padding: '8px' }}>{show.region}</td>
                <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                  {formatDate(show.startDate)}
                </td>
                <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                  {formatDateTime(show.endDate)} EDT
                </td>
                <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                  {timeRemaining[show._id] || 'Calculating...'}
                </td>
                <td style={{ border: '1px solid #ddd', padding: '8px' }}>{show.specialtyBreed}</td>
                <td style={{ border: '1px solid #ddd', padding: '8px' }}>{show.featuredJudge}</td>
                <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                  <Link to={`/merit-confo/show/${show._id}`}>
                    <button
                      style={{
                        padding: '5px 10px',
                        backgroundColor: '#1E88E5',
                        color: 'white',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer',
                      }}
                    >
                      View Show
                    </button>
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );

  return (
    <div className="merit-confo-show-list-container">
      {renderShowTable([...openShows, ...pendingShows], 'Open and Pending iCON Merit Conformation Shows')}
      {renderShowTable(closedShows, 'Closed iCON Merit Conformation Shows')}
    </div>
  );
}

export default MeritConfoShowList;